//AbstractZimbraInstance
import GenericModel       from './GenericModel';
import { FormControl }  from '@angular/forms';

export default class AbstractZimbraInstance extends GenericModel
{
        code   :  string;
        name   :  string;
        url   :  string;
        auth_token   :  string;
        domain_name : string;
    
    constructor(dict = null)
    {
        super(dict);
        if (dict !== null)
        {
            this.code = dict["code"]            || null;
            this.name = dict["name"]            || null;
            this.domain_name = dict["domain_name"]            || null;
            this.url = dict["url"]            || null;
            this.auth_token = dict["auth_token"]            || null;
        }
    }
}
